export const DELETE_OR_CANCEL_EVENT_CLICKED = 'DeleteOrCancelEventClicked';
export const DELETE_OR_CANCEL_EVENT_ABORT = 'DeleteOrCancelEventAbort';
export const DELETE_OR_CANCEL_EVENT_CONFIRM_CLICKED = 'DeleteEvent';
export const DELETE_OR_CANCEL_EVENT_COMPLETE = 'DeleteOrCancelEventComplete';
export const DELETE_OR_CANCEL_EVENT_RETRY_CLICKED = 'DeleteOrCancelEventRetryClicked';
export const EVENT_CLICKED = 'EventClicked';
export const RSVP_EVENT_CLICKED = 'RSVPEventClicked';
export const RSVP_EVENT_SEND = 'meetingMessageAction';
export const RSVP_EVENT_COMPLETE = 'RSVPEventComplete';
export const RSVP_OVERLAY_CLICKED = 'RSVPOverlayClicked';
export const VIEW_BUTTON_CLICKED = 'ViewButtonClicked';
export const EVENT_READING_PANE_LOADED = 'EventReadingPaneLoaded';
export const RSVP_RENDERED = 'RsvpRendered';
export const PARTIAL_RSVP_RENDERED = 'PartialRsvpRendered';
export const COMPLETE_RSVP_RENDERED = 'CompleteRsvpRendered';
export const EVENT_CAPTURE_DISCARDED = 'EventDiscarded';
export const EVENT_EDIT_CLICKED = 'EventEditClicked';
export const SAVE_CAL_EVENT = 'SaveCalendarEvent';
